export default __webpack_public_path__ + "static/media/news-16.bcee74a8.jpeg";